import React from 'react';
import { Header } from 'semantic-ui-react';
import { SortIndicator } from 'react-virtualized';

const explainers = {
  thirtyMinBaseValue:
    'Total trading volume (Base token) over the last 30 minutes.',
  thirtyMinBaseVolumeAvgChange:
    'Percent above average 30 minute base volume for quote token',
  thirtyMinBsRatio:
    'Buy (Seller is market maker) vs Sell (Buyer is market maker) ratio over last 30 minutes',
  fiveMinBsRatio:
    'Buy (Seller is market maker) vs Sell (Buyer is market maker) ratio over last 5 minutes',
  rsi: 'Relative strength index',
};

const style = { fontSize: '0.8em', fontWeight: 400 };

const HeaderCell = props => {
  const {
    // columnData,
    dataKey,
    // disableSort,
    label,
    sortBy,
    sortDirection,
  } = props;
  // console.log('PROPS: ', props);
  // const ticker =
  // return <div>Header</div>;
  const showSortIndicator = sortBy === dataKey;
  let el = (
    <Header
      style={style}
      size="tiny"
      inverted
      content={label}
      textAlign="center"
    />
  );

  if (showSortIndicator) {
    el = (
      <Header style={style} size="tiny" inverted textAlign="center">
        {label}
        <SortIndicator key="SortIndicator" sortDirection={sortDirection} />
      </Header>
    );
  }

  if (!explainers[dataKey]) {
    return el;
  }
  // return <Popup trigger={el} content={explainers[dataKey]} />;
  return el;
};

export default HeaderCell;



// WEBPACK FOOTER //
// ./src/containers/Markets/components/MarketsTable/components/MarketsTableComponent/components/HeaderCell/index.jsx